window.addEventListener('DOMContentLoaded', () => {
  let discountCodeClick = document.querySelectorAll('.paymentBtnWrapper button');
  let discountCodeDta = document.querySelector('.discount-code-input');
  if(discountCodeDta){
    let discountCodemesDta = discountCodeDta.innerHTML;
    discountCodeClick.forEach(btn => {
      btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.applyCartDiscount) {
        window.applyCartDiscount(discountCodemesDta);
      }
      fetch(`/discount/${discountCodemesDta}`,{method: 'GET'})
      .then(() => {
        console.log('success');
      })
      .catch(err => console.log(err))
    })
  });
  }

  const notifyBtn = document.querySelectorAll(".notify_desktop-pdp-button"),
  form_state = document.querySelector('.form-state');

if (notifyBtn) {
  const popupContainer = document.querySelector(".notify_popup_container"),
      closeBtn = document.querySelector(".notify_close_popup"),
      closeIconBtn = document.querySelector(".notify_close_btn"),
      notifySend = form_state.querySelector('#sendButton'),
      notifyProductForm = form_state.querySelector('#ContactForm-NotifyFun');
      thankYouMessage = document.getElementById('thank_you');
    
    notifyBtn.forEach((custobtn) => {
    custobtn.addEventListener("click", function(event) {
        event.preventDefault();
            popupContainer.classList.add("active");
            document.body.classList.add("overlay_bulkpopup");
            thankYouMessage.style.display = 'none'; 
            form_state.style.display = 'block';
            closeBtn.style.display = 'block';
      });
    });

    closeBtn.addEventListener("click", function(event) {
        event.preventDefault();
        popupContainer.classList.remove("active"); 
        document.body.classList.remove("overlay_bulkpopup");
    });

    closeIconBtn.addEventListener("click", function(event) {
      event.preventDefault();
      popupContainer.classList.remove("active"); 
      document.body.classList.remove("overlay_bulkpopup");
      notifyProductForm.submit(); 
  });

    notifySend.addEventListener('click', function(event) {
        event.preventDefault();
        
        const username = form_state.querySelector('[name="contact[Full Name]"]').value,
            mobile_number = form_state.querySelector('[name="contact[Phone number]"]').value,
            email = form_state.querySelector('[name="contact[email]"]').value,
            pname = form_state.querySelector('[name="contact[Product Name]"]').value,
            pid = form_state.querySelector('[name="contact[Product ID]"]').value,
            vSKU = form_state.querySelector('[name="contact[Variant SKU]"]').value,
            vname = form_state.querySelector('[name="contact[Variant Name]"]').value,
            formname = form_state.querySelector('[name="contact[Form Type]"]').value,
            variant_id = form_state.querySelector('[name="contact[Variant ID]"]').value, 
            page_url = location.href;
            console.log(page_url);
        if (username.trim() === '' || mobile_number.trim() === '' || email.trim() === '') {
          alert('Please fill out all fields');
          return false;
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          alert('Please enter a valid email address');
          return false;
        }

        const mobilePattern = /^\d{10}$/;
        if (!mobilePattern.test(mobile_number)) {
          alert('Please enter a valid 10-digit mobile number');
          return false;
        }
          notifySend.classList.add('loading');
          fetch('https://pebble.livwell.asia/Notifyme/UserData', {
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-type": "application/json",
              "Authorization": `Bearer ${window.sessionToken}`
            },
            body: JSON.stringify({
              customer_username: username,
              customer_mobile_number: mobile_number,
              customer_email: email,
              variant_id: variant_id,
              product_name: pname,
              form_type: formname,
              product_id: pid,
              variant_SKU: vSKU,
              variant_name: vname,
              url: page_url
            })
          })
          .then(res => {
            setTimeout(() => {
              notifyProductForm.submit(); 
            }, 5000);
            thankYouMessage.style.display = 'block';
            closeBtn.style.display = 'none';
             notifySend.classList.remove('loading');
            form_state.style.display = 'none';
          })
    });
}

  document.addEventListener('variant:change', (vardata) => {
    form_state.querySelector('[name="contact[Variant ID]"]').value = vardata.detail.variant.id;
    form_state.querySelector('[name="contact[Variant SKU]"]').value = vardata.detail.variant.sku;
    console.log(vardata.detail.variant);
        var sizeNumber = vardata.detail.variant.option2;

    var labels = document.querySelectorAll('.form__label-info');
    if (labels.length > 1) {
      labels[1].textContent = '– ' + sizeNumber; // second element
    }
    form_state.querySelector('[name="contact[Variant Name]"]').value = vardata.detail.variant.title;
    const productaForms = document.querySelectorAll('.payment_custom_btn');
    productaForms.forEach((productForm) => {
      if(productForm.classList.contains('notify_fun_on')){
        console.log('vardata.detail.variant.available',vardata.detail.variant.available);
        if(vardata.detail.variant.available == false){
          productForm.querySelector('.pdp-notify-button').style.display = "block";
          productForm.querySelector('.btn_main_payments').style.display = "none";
        }
        else{
          productForm.querySelector('.pdp-notify-button').style.display = "none";
          productForm.querySelector('.btn_main_payments').style.display = "block";
        }
      }
    })
  });
});

class Product {
  constructor() {
    if (window.innerWidth <= 749) {
      this.VariantOptOnMobile();
    }
  }
  
  buyNowBtnText = () => {
    let buyBtnWrapper = document.querySelector('.paymentBtnWrapper');
    let buyBtnObserver = new MutationObserver(() => {
      let buyBtns = document.querySelectorAll('.paymentBtnWrapper button');
      buyBtns.forEach(btn => {
        setTimeout(() => {
          if (btn.textContent == 'Buy it now') {
            btn.textContent = 'Buy Now'
          }
        }, 200);
      });
    });
    buyBtnObserver.observe(buyBtnWrapper, {subtree: true, childList: true});
  }

  VariantOptOnMobile = () => {
    const varBtnEle = document.querySelector('.main-product-section variant-radios');
    const PdpGridWrapper = document.querySelector('.mobile_variant');
    if(varBtnEle) {
      PdpGridWrapper.appendChild(varBtnEle); 
      PdpGridWrapper.style.height = 'auto';
    }
  }

}
new Product;

class pdpStripline extends HTMLElement {
  constructor() {
    super();
    this.onscrollStrip();  
    this.onclickStrip();
    this.backToTop();
    this.removeBlankLinks();
  }

  getTargetElement = (btn) => {
    let href = btn.getAttribute('href');
    if (!href || href === '#') return null;
    
    // 1. Try exact selector matching
    try {
      let target = document.querySelector(href);
      if (target) return target;
    } catch (e) {
      // ignore invalid selector error
    }
    
    // 2. Try suffix match if it's a dynamic Shopify section ID (e.g. shopify-section-template--...__xxxxx)
    if (href.includes('__')) {
      let parts = href.split('__');
      let suffix = parts[parts.length - 1];
      try {
        let target = document.querySelector(`[id$="__${suffix}"]`);
        if (target) return target;
      } catch (e) {}
    }
    
    // 3. Fallback to mapped class selectors based on button ID
    let btnId = btn.getAttribute('id');
    if (btnId === 'overview') {
      let target = document.querySelector('#aPlusVideoSection') || document.querySelector('.a-plus-content-section');
      if (target) return target;
    } else if (btnId === 'specifications') {
      let target = document.querySelector('.collapsible-content-section') || document.querySelector('#pdpSpefificationSec');
      if (target) return target;
    } else if (btnId === 'faqs') {
      let target = document.querySelector('.faqs-section') || document.querySelector('#pdpFaqs');
      if (target) return target;
    } else if (btnId === 'reviews') {
      let target = document.querySelector('#shopify-block-loox-product-reviews') || 
                   document.querySelector('#loox-product-reviews') || 
                   document.querySelector('.loox-reviews-default') ||
                   document.querySelector('[id*="reviews"]');
      if (target) return target;
    }
    
    return null;
  }

  removeBlankLinks = () => {
    let aplusContent = document.querySelector('.a-plus-content-section'),
        heroVideo = document.querySelector('#aPlusVideoSection'),
        specification = document.querySelector('.collapsible-content-section'),
        faqs = document.querySelector('.faqs-section'),
        reviews = document.querySelector('#shopify-block-loox-product-reviews');
    let overviewBtn = document.querySelector('#overview'),
        specificationsBtn = document.querySelector('#specifications'),
        faqsBtn = document.querySelector('#faqs'),
        reviewsBtn = document.querySelector('#reviews');
        
        if (overviewBtn) {
          let aplusHidden = !aplusContent || window.getComputedStyle(aplusContent).display === "none";
          let videoHidden = !heroVideo || window.getComputedStyle(heroVideo).display === "none";
          if (aplusHidden && videoHidden) {
            overviewBtn.style.display = 'none';
            overviewBtn.classList.add('hidden');
          }
        }
        if (specificationsBtn) {
          let specHidden = !specification || window.getComputedStyle(specification).display === "none";
          if (specHidden) {
            specificationsBtn.style.display = 'none';
            specificationsBtn.classList.add('hidden');
          }
        }
        if (faqsBtn) {
          let faqsHidden = !faqs || window.getComputedStyle(faqs).display === "none";
          if (faqsHidden) {
            faqsBtn.style.display = 'none';
            faqsBtn.classList.add('hidden');
          }
        }
        // if (reviewsBtn) {
        //   let reviewsHidden = !reviews || window.getComputedStyle(reviews).display === "none";
        //   if (reviewsHidden) {
        //     reviewsBtn.style.display = 'none';
        //     reviewsBtn.classList.add('hidden');
        //   }
        // }
  }

  backToTop = () => {
    let trigger = this.querySelector('#backToTop');
    if (trigger) {
      trigger.addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
      })
    }
  }

  onscrollStrip = () => {
    window.addEventListener('scroll', () => {
      let crollPosition = window.pageYOffset;
      let positionEle = this.querySelectorAll('.strip-item:not(.hidden)');
      positionEle.forEach(ele => {
        let target = this.getTargetElement(ele);
        if (target) {
          let offset = target.offsetTop - 80; 
          if (crollPosition >= offset) {
            positionEle.forEach(btns => btns.classList.remove('active'))
            ele.classList.add('active')
          }
        }
      })
    }, {passive: true});
  }

  onclickStrip = () => {
    let btns = this.querySelectorAll('.strip-item');
    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        let target = this.getTargetElement(e.currentTarget);
        if (target) {
          let offset = target.offsetTop - 50; 
          btns.forEach(btn => btn.classList.remove('active'))
          e.currentTarget.classList.add('active');
          window.scrollTo({top: offset, behavior: 'smooth'});
        }
      })
    })
  }
}
customElements.define('pdp-stripline', pdpStripline);